"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var WrappedPropertyBoolean = /** @class */ (function (_super) {
    __extends(WrappedPropertyBoolean, _super);
    function WrappedPropertyBoolean(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        // //export const wrapSchemaProps = ['maxLength', 'minLength', 'maxItems', 'minItems', 'minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum', 'precision'];
        // wrapSchemaProps(this.$schema, this._internal, 'number', ['maxItems', 'minItems']);
        functions_1.initVue(_this, _this._internal);
        return _this;
    }
    WrappedPropertyBoolean.prototype.$validate = function (value) {
        if (value === undefined) {
            value = this.$model;
        }
        this.$dirty = true;
        if (value === null) {
            if (this.$schema.fieldRequired) {
                return functions_1.getRuleMessage(this._internal, 'required', value, this.$schema);
            }
            if (this.$schema.enum) {
                if (this.$schema.enum.indexOf(value) === -1) {
                    return functions_1.getRuleMessage(this._internal, 'enum', value, this.$schema);
                }
            }
            return null;
        }
        var ivalue = !!value;
        if (this.$schema.fieldRequired && !ivalue) {
            return functions_1.getRuleMessage(this._internal, 'required', value, this.$schema);
        }
        return _super.prototype.$validate.call(this, ivalue);
    };
    WrappedPropertyBoolean.prototype.$check = function (value, checkResult) {
        if (this._internal.schema.warnings) {
            if (value === undefined) {
                value = this.$model;
            }
            this.$dirty = true;
            checkResult = checkResult || [];
            if (value === null) {
                if (this.$schema.warnings.fieldRequired) {
                    checkResult.push(functions_1.getWarningMessage(this._internal, 'required', value, this.$schema));
                }
                if (this.$schema.warnings.enum) {
                    if (this.$schema.warnings.enum.indexOf(value) === -1) {
                        checkResult.push(functions_1.getWarningMessage(this._internal, 'enum', value, this.$schema));
                    }
                }
                return checkResult;
            }
            var ivalue = !!value;
            if (this.$schema.fieldRequired && !ivalue) {
                checkResult.push(functions_1.getWarningMessage(this._internal, 'required', value, this.$schema));
            }
            return _super.prototype.$check.call(this, ivalue, checkResult);
        }
        return [];
    };
    WrappedPropertyBoolean.prototype.getValue = function () {
        var svalue = this.$model;
        /*
        if (this.$dirty) {
          this.$validate(svalue);
        }
        */
        return svalue ? 'true' : 'false';
    };
    WrappedPropertyBoolean.prototype.setValue = function (newValue) {
        if (!this.$dirty && this._internal.options.dirtyOnInput) {
            this.$dirty = true;
        }
        if (newValue === null || newValue === 'null') {
            this.$model = null;
        }
        else {
            this.$model = newValue !== 'false' && newValue !== 'off' && newValue !== '';
        }
    };
    return WrappedPropertyBoolean;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyBoolean;
WrappedPropertyCtor_1.default.boolean = WrappedPropertyBoolean;
//# sourceMappingURL=WrappedPropertyBoolean.js.map